module.exports = __webpack_public_path__ + "img/resonator_fp_design.d939f681.svg";